var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmazone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "IMDb, an Amazon company",
    title: "IMDb, an Amazon company",
    width: 160,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.707 2.45c-3.227 2.374-7.906 3.637-11.935 3.637C9.125 6.087 4.04 4.006.193.542-.11.27.161-.101.523.109 4.675 2.517 9.81 3.968 15.111 3.968c3.577 0 7.51-.74 11.127-2.27.546-.23 1.003.358.47.752z",
    id: "ftr__a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.113 1.677C3.7 1.15 1.385 1.427.344 1.552c-.315.037-.364-.237-.08-.436C2.112-.178 5.138.196 5.49.629c.354.437-.093 3.462-1.824 4.906-.266.222-.52.104-.401-.19.39-.97 1.261-3.14.848-3.668z",
    id: "ftr__c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.435 1.805V.548A.311.311 0 0 1 .755.23l5.65-.001c.181 0 .326.13.326.317v1.078c-.002.181-.154.417-.425.791L3.378 6.582c1.087-.026 2.236.137 3.224.69.222.125.282.309.3.49v1.342c0 .185-.203.398-.417.287-1.74-.908-4.047-1.008-5.97.011-.197.104-.403-.107-.403-.292V7.835c0-.204.004-.552.21-.863l3.392-4.85H.761a.314.314 0 0 1-.326-.317z",
    id: "ftr__e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.247 9.655H.528a.323.323 0 0 1-.307-.29L.222.569C.222.393.37.253.554.253h1.601a.323.323 0 0 1 .313.295v1.148h.031C2.917.586 3.703.067 4.762.067c1.075 0 1.75.518 2.23 1.629C7.41.586 8.358.067 9.369.067c.722 0 1.508.296 1.99.963.545.74.433 1.813.433 2.757l-.002 5.551a.324.324 0 0 1-.331.317H9.74a.321.321 0 0 1-.308-.316l-.001-4.663c0-.37.032-1.296-.048-1.647-.128-.593-.514-.76-1.011-.76-.418 0-.85.278-1.027.722-.177.445-.161 1.185-.161 1.685v4.662a.323.323 0 0 1-.331.317H5.137a.322.322 0 0 1-.31-.316l-.001-4.663c0-.981.16-2.424-1.059-2.424-1.236 0-1.188 1.406-1.188 2.424v4.662a.324.324 0 0 1-.332.317z",
    id: "ftr__g"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.037.067c2.551 0 3.931 2.184 3.931 4.96 0 2.684-1.524 4.814-3.931 4.814C1.533 9.84.169 7.656.169 4.935.17 2.195 1.55.067 4.037.067zm.015 1.796c-1.267 0-1.347 1.721-1.347 2.795 0 1.073-.016 3.368 1.332 3.368 1.332 0 1.395-1.851 1.395-2.98 0-.74-.031-1.629-.256-2.332-.193-.61-.578-.851-1.124-.851z",
    id: "ftr__i"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.206 9.655H.493a.321.321 0 0 1-.308-.316L.182.54a.325.325 0 0 1 .33-.287h1.595c.15.007.274.109.305.245v1.346h.033C2.926.641 3.6.067 4.788.067c.77 0 1.524.277 2.006 1.037.449.703.449 1.887.449 2.739v5.535a.325.325 0 0 1-.33.277H5.19a.324.324 0 0 1-.306-.277V4.602c0-.962.113-2.37-1.075-2.37-.418 0-.803.278-.995.704-.24.537-.273 1.074-.273 1.666v4.736a.328.328 0 0 1-.335.317z",
    id: "ftr__k"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.314 8.295c.11.156.134.341-.006.455-.35.294-.974.834-1.318 1.139l-.004-.004a.357.357 0 0 1-.406.04c-.571-.473-.673-.692-.986-1.142-.943.958-1.611 1.246-2.834 1.246-1.447 0-2.573-.89-2.573-2.672 0-1.39.756-2.337 1.833-2.8.933-.409 2.235-.483 3.233-.595V3.74c0-.409.032-.89-.209-1.243-.21-.315-.611-.445-.965-.445-.656 0-1.238.335-1.382 1.029-.03.154-.143.307-.298.315l-1.667-.18c-.14-.032-.297-.144-.256-.358C.859.842 2.684.234 4.32.234c.837 0 1.93.222 2.59.853.836.78.755 1.818.755 2.95v2.67c0 .804.335 1.155.65 1.588zM5.253 5.706v-.37c-1.244 0-2.557.265-2.557 1.724 0 .742.386 1.244 1.045 1.244.483 0 .917-.297 1.19-.78.338-.593.322-1.15.322-1.818z",
    id: "ftr__m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.203 8.295c.11.156.135.341-.005.455-.352.294-.976.834-1.319 1.139l-.004-.004a.356.356 0 0 1-.406.04c-.571-.473-.673-.692-.985-1.142-.944.958-1.613 1.246-2.835 1.246-1.447 0-2.573-.89-2.573-2.672 0-1.39.756-2.337 1.833-2.8.933-.409 2.236-.483 3.233-.595V3.74c0-.409.032-.89-.21-1.243-.208-.315-.61-.445-.964-.445-.656 0-1.239.335-1.382 1.029-.03.154-.142.307-.298.315l-1.666-.18C.48 3.184.324 3.072.365 2.858.748.842 2.573.234 4.209.234c.836 0 1.93.222 2.59.853.835.78.755 1.818.755 2.95v2.67c0 .804.335 1.155.649 1.588zM5.142 5.706v-.37c-1.243 0-2.557.265-2.557 1.724 0 .742.386 1.244 1.045 1.244.482 0 .917-.297 1.19-.78.338-.593.322-1.15.322-1.818z",
    id: "ftr__o"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.935 10.148c-.88 0-1.583-.25-2.11-.75-.527-.501-.79-1.171-.79-2.011 0-.902.322-1.622.967-2.159.644-.538 1.511-.806 2.602-.806.694 0 1.475.104 2.342.315V3.513c0-.667-.151-1.136-.455-1.408-.304-.271-.821-.407-1.553-.407-.855 0-1.691.123-2.509.37-.285.087-.464.13-.539.13-.148 0-.223-.111-.223-.334v-.5c0-.16.025-.278.075-.352C.79.938.89.87 1.039.808c.383-.173.87-.312 1.459-.417A9.997 9.997 0 0 1 4.255.234c1.177 0 2.045.244 2.602.731.557.489.836 1.233.836 2.233v6.338c0 .247-.124.37-.372.37h-.798c-.236 0-.373-.117-.41-.351l-.093-.612c-.445.383-.939.68-1.477.89-.54.21-1.076.315-1.608.315zm.446-1.39c.41 0 .836-.08 1.282-.241.447-.16.874-.395 1.283-.704v-1.89a8.408 8.408 0 0 0-1.97-.241c-1.401 0-2.1.537-2.1 1.612 0 .47.13.831.39 1.084.26.254.632.38 1.115.38z",
    id: "ftr__q"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.467 9.907c-.248 0-.372-.124-.372-.37V.883C.095.635.219.51.467.51h.817c.125 0 .22.026.288.075.068.05.115.142.14.277l.111.686C3 .672 4.24.234 5.541.234c.904 0 1.592.238 2.063.713.471.476.707 1.165.707 2.066v6.524c0 .246-.124.37-.372.37H6.842c-.248 0-.372-.124-.372-.37V3.625c0-.655-.133-1.137-.4-1.445-.266-.31-.684-.464-1.254-.464-.979 0-1.94.315-2.881.946v6.875c0 .246-.125.37-.372.37H.467z",
    id: "ftr__s"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.641 9.859c-1.462 0-2.58-.417-3.355-1.251C.51 7.774.124 6.566.124 4.985c0-1.569.4-2.783 1.2-3.641C2.121.486 3.252.055 4.714.055c.67 0 1.326.118 1.971.353.136.05.232.111.288.185.056.074.083.198.083.37v.501c0 .248-.08.37-.241.37-.062 0-.162-.018-.297-.055a5.488 5.488 0 0 0-1.544-.222c-1.04 0-1.79.262-2.248.787-.459.526-.688 1.362-.688 2.511v.241c0 1.124.232 1.949.697 2.474.465.525 1.198.788 2.203.788a5.98 5.98 0 0 0 1.672-.26c.136-.037.23-.056.279-.056.161 0 .242.124.242.371v.5c0 .162-.025.279-.075.353-.05.074-.148.142-.297.204-.608.259-1.314.389-2.119.389z",
    id: "ftr__u"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.598 10.185c-1.413 0-2.516-.438-3.31-1.316C.497 7.992.1 6.769.1 5.199c0-1.555.397-2.773 1.19-3.65C2.082.673 3.185.235 4.598.235c1.412 0 2.515.438 3.308 1.316.793.876 1.19 2.094 1.19 3.65 0 1.569-.397 2.792-1.19 3.669-.793.878-1.896 1.316-3.308 1.316zm0-1.483c1.747 0 2.62-1.167 2.62-3.502 0-2.323-.873-3.484-2.62-3.484S1.977 2.877 1.977 5.2c0 2.335.874 3.502 2.62 3.502z",
    id: "ftr__w"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.396 9.907c-.248 0-.371-.124-.371-.37V.883C.025.635.148.51.396.51h.818a.49.49 0 0 1 .288.075c.068.05.115.142.14.277l.111.594C2.943.64 4.102.234 5.23.234c1.152 0 1.934.438 2.342 1.315C8.798.672 10.025.234 11.25.234c.856 0 1.512.24 1.971.722.458.482.688 1.168.688 2.057v6.524c0 .246-.124.37-.372.37h-1.097c-.248 0-.371-.124-.371-.37V3.533c0-.618-.119-1.075-.354-1.372-.235-.297-.607-.445-1.115-.445-.904 0-1.815.278-2.732.834.012.087.018.18.018.278v6.709c0 .246-.124.37-.372.37H6.42c-.249 0-.372-.124-.372-.37V3.533c0-.618-.118-1.075-.353-1.372-.235-.297-.608-.445-1.115-.445-.942 0-1.847.272-2.714.815v7.006c0 .246-.125.37-.372.37H.396z",
    id: "ftr__y"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.617 13.724c-.248 0-.371-.124-.371-.37V.882c0-.247.123-.37.371-.37h.818c.248 0 .39.123.428.37l.093.594C2.897.648 3.944.234 5.096.234c1.203 0 2.15.435 2.845 1.307.693.87 1.04 2.053 1.04 3.548 0 1.52-.365 2.736-1.096 3.65-.731.915-1.704 1.372-2.918 1.372-1.116 0-2.076-.365-2.881-1.094v4.337c0 .246-.125.37-.372.37H.617zM4.54 8.628c1.71 0 2.566-1.149 2.566-3.447 0-1.173-.208-2.044-.624-2.612-.415-.569-1.05-.853-1.904-.853-.88 0-1.711.284-2.491.853v5.17c.805.593 1.623.889 2.453.889z",
    id: "ftr__A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.971 10.148c-.88 0-1.583-.25-2.11-.75-.526-.501-.79-1.171-.79-2.011 0-.902.322-1.622.967-2.159.644-.538 1.512-.806 2.602-.806.694 0 1.475.104 2.342.315V3.513c0-.667-.15-1.136-.455-1.408-.304-.271-.821-.407-1.552-.407-.855 0-1.692.123-2.509.37-.285.087-.465.13-.54.13-.148 0-.223-.111-.223-.334v-.5c0-.16.025-.278.075-.352.05-.074.148-.142.297-.204.384-.173.87-.312 1.46-.417A9.991 9.991 0 0 1 4.29.234c1.177 0 2.045.244 2.603.731.557.489.836 1.233.836 2.233v6.338c0 .247-.125.37-.372.37h-.799c-.236 0-.372-.117-.41-.351l-.092-.612a5.09 5.09 0 0 1-1.478.89 4.4 4.4 0 0 1-1.608.315zm.446-1.39c.41 0 .836-.08 1.283-.241.446-.16.874-.395 1.282-.704v-1.89a8.403 8.403 0 0 0-1.97-.241c-1.4 0-2.1.537-2.1 1.612 0 .47.13.831.39 1.084.26.254.632.38 1.115.38z",
    id: "ftr__C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.503 9.907c-.248 0-.371-.124-.371-.37V.883C.132.635.255.51.503.51h.818a.49.49 0 0 1 .288.075c.068.05.115.142.14.277l.111.686C3.037.672 4.277.234 5.578.234c.904 0 1.592.238 2.063.713.47.476.706 1.165.706 2.066v6.524c0 .246-.123.37-.371.37H6.879c-.248 0-.372-.124-.372-.37V3.625c0-.655-.133-1.137-.4-1.445-.266-.31-.684-.464-1.254-.464-.98 0-1.94.315-2.882.946v6.875c0 .246-.124.37-.371.37H.503z",
    id: "ftr__E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.988 13.443c-.397 0-.75-.043-1.059-.13-.15-.037-.251-.1-.307-.185a.684.684 0 0 1-.084-.37v-.483c0-.234.093-.352.28-.352.06 0 .154.013.278.037.124.025.291.037.502.037.459 0 .82-.114 1.087-.343.266-.228.505-.633.716-1.213l.353-.945L.167.675C.08.465.037.316.037.23c0-.149.086-.222.26-.222h1.115c.198 0 .334.03.409.093.075.062.148.197.223.407l2.602 7.19 2.51-7.19c.074-.21.148-.345.222-.407.075-.062.211-.093.41-.093h1.04c.174 0 .261.073.261.222 0 .086-.044.235-.13.445l-4.09 10.377c-.334.853-.725 1.464-1.17 1.835-.446.37-1.017.556-1.711.556z",
    id: "ftr__G"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.496 11.553)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ftr__b",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ftr__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    mask: "url(#ftr__b)",
    d: "M.04 6.088h26.91V.04H.04z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.433 10.797)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ftr__d",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ftr__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    mask: "url(#ftr__d)",
    d: "M.05 5.664h5.564V.222H.05z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.433 .97)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ftr__f",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ftr__e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    mask: "url(#ftr__f)",
    d: "M.11 9.444h6.804V.222H.111z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.008 .97)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ftr__h",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ftr__g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    mask: "url(#ftr__h)",
    d: "M.191 9.655h11.611V.04H.192z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.992 .97)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ftr__j",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ftr__i"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    mask: "url(#ftr__j)",
    d: "M.141 9.867h7.831V.04H.142z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.063 .97)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ftr__l",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ftr__k"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    mask: "url(#ftr__l)",
    d: "M.171 9.655h7.076V.04H.17z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.11 .718)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ftr__n",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ftr__m"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    mask: "url(#ftr__n)",
    d: "M.181 10.059h8.225V.232H.18z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.685 .718)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ftr__p",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ftr__o"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    mask: "url(#ftr__p)",
    d: "M.05 10.059h8.255V.232H.05z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .718)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ftr__r",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ftr__q"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    mask: "url(#ftr__r)",
    d: "M.03 10.15h7.68V.231H.03z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.33 .718)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ftr__t",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ftr__s"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    mask: "url(#ftr__t)",
    d: "M.07 9.907h8.255V.232H.071z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(84.157 .97)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ftr__v",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ftr__u"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    mask: "url(#ftr__v)",
    d: "M.11 9.867h7.046V.04H.11z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(92.472 .718)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ftr__x",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ftr__w"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    mask: "url(#ftr__x)",
    d: "M.08 10.21h9.041V.232H.081z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(103.811 .718)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ftr__z",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ftr__y"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    mask: "url(#ftr__z)",
    d: "M.02 9.907H13.93V.232H.02z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120.189 .718)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ftr__B",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ftr__A"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    mask: "url(#ftr__B)",
    d: "M.242 13.747H9.01V.232H.242z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(130.772 .718)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ftr__D",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ftr__C"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    mask: "url(#ftr__D)",
    d: "M.06 10.15h7.68V.231H.06z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(141.102 .718)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ftr__F",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ftr__E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    mask: "url(#ftr__F)",
    d: "M.131 9.907h8.224V.232H.131z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(150.677 1.222)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ftr__H",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ftr__G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    mask: "url(#ftr__H)",
    d: "M.02 13.455h9.071V0H.021z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazone);
export default __webpack_public_path__ + "static/media/amazone.7f1285cb498b86f993e9b2bbbddf7f2f.svg";
export { ForwardRef as ReactComponent };